/**
 * <sg-reviews-list>: Filter nach Thema, Sortierung und „Alle anzeigen“ für die Bewertungsseite.
 * Im HTML steht die ganze Liste, die Leiste ist versteckt. Ohne JavaScript bleibt also alles lesbar.
 */
class SgReviewsList extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-list]');
    this.items = [...this.querySelectorAll('[data-review]')];
    this.chips = [...this.querySelectorAll('[data-theme]')];
    this.more = this.querySelector('[data-more]');
    this.empty = this.querySelector('[data-empty]');
    this.sort = this.querySelector('[data-sort]');
    this.mobile = window.matchMedia('(max-width: 768px)');
    this.theme = '';
    this.expanded = false;

    this.dataset.ready = '';
    this.querySelector('[data-toolbar]').hidden = false;
    this.chips.forEach((chip) => chip.addEventListener('click', () => this.select(chip)));
    this.sort.addEventListener('change', () => this.update());
    this.more.addEventListener('click', () => {
      this.expanded = true;
      this.update();
    });
    this.list.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-toggle]');
      if (!toggle) return;
      toggle.closest('[data-review]').classList.add('is-open');
      toggle.hidden = true;
    });
    this.sync = () => this.update();
    this.mobile.addEventListener('change', this.sync);
    this.update();
    document.fonts.ready.then(() => this.markLong());
  }

  disconnectedCallback() {
    this.mobile.removeEventListener('change', this.sync);
  }

  select(chip) {
    this.theme = chip.dataset.theme;
    this.expanded = false;
    this.chips.forEach((item) => item.setAttribute('aria-pressed', String(item === chip)));
    this.update();
  }

  sorted(items) {
    const byDate = (a, b) => b.dataset.date.localeCompare(a.dataset.date);
    const direction = { high: 1, low: -1 }[this.sort.value];
    if (!direction) return [...items].sort(byDate);
    return [...items].sort((a, b) => direction * (b.dataset.stars - a.dataset.stars) || byDate(a, b));
  }

  // „Mehr lesen“ nur bei Texten, die die sechs Zeilen wirklich überschreiten
  markLong() {
    this.items.forEach((item) => {
      if (item.hidden || item.classList.contains('is-open')) return;
      const text = item.querySelector('.reviews-list__text');
      item.querySelector('[data-toggle]').hidden = text.scrollHeight <= text.clientHeight;
    });
  }

  update() {
    const matches = this.items.filter((item) => !this.theme || item.dataset.themes.split(' ').includes(this.theme));
    const limit = this.expanded ? matches.length : this.mobile.matches ? 4 : 9;

    this.items.forEach((item) => (item.hidden = true));
    this.sorted(matches).forEach((item, index) => {
      this.list.append(item);
      item.hidden = index >= limit;
    });

    this.more.hidden = matches.length <= limit;
    this.more.textContent = this.dataset.moreLabel.replace('__count__', matches.length);
    this.empty.hidden = matches.length > 0;
    this.markLong();
  }
}

customElements.define('sg-reviews-list', SgReviewsList);
